module.exports = __webpack_public_path__ + "img/vendor_logo6.42f74085.png";